import React from "react";
import { PlusOutlined, FileExcelOutlined } from "@ant-design/icons";
import {
  Drawer,
  Button,
  PageHeader,
} from "antd";
import { useState } from "react";



import AdminBreadCrumb from "../../components/layout/AdminBreadCrumb";


import TimeSlotEntry from "../../components/masters/time-slot/TimeSlotEntry";
import TimeSlotList from "../../components/masters/time-slot/TimeSlotList";
import DrawableCloseIcon from "../../components/common/DrawableCloseIcon";
import { DEFAULT_MASTER_DRAWER_WIDTH } from "../../utility/Constants";
import { ALL_TIME_SLOT_XLS_URL } from "../../utility/URL";
import commonUtility from "../../utility/Utils";





const TimeSlot = () => {
  const [visible, setVisible] = useState(false);
  const [timeSlotAddData, setTimeSlotAddData] = useState({
    time_slot_id: 0,
    programme_id: '',
    programme_group_id: '',
    start_time: '',
    end_time: '',
    time_slot: '',
    is_active: "Y",
    mode: "ADD",
    morning_or_special_coaching: '',
    day_id: ''
  });

  const showDrawer = () => {
    setVisible(true);
  };

  const onClose = () => {
    setVisible(false);
  };


  return (
    <div className="inside-main-content">
      <AdminBreadCrumb />

      <div className="box-style">
        <PageHeader
          ghost={false}
          onBack={() => window.history.back()}
          title="Time Slot"
          subTitle=""
          extra={[
            <Button key="1" className="custom-button-white" shape="round" onClick={showDrawer}>
              <PlusOutlined /> Add
            </Button>,

            <Button key="2" className="custom-button-white" shape="round" size="medium" onClick={() => commonUtility.openInNewTab(ALL_TIME_SLOT_XLS_URL)}>
              <FileExcelOutlined /> Excel
            </Button>,
          ]}
        ></PageHeader>

        <Drawer
          title="Add new time slot"
          width={DEFAULT_MASTER_DRAWER_WIDTH}
          onClose={onClose}
          visible={visible}
          bodyStyle={{
            paddingBottom: 80,
          }}
          destroyOnClose={true}
          closeIcon={<><DrawableCloseIcon /></>}
        >
          <TimeSlotEntry data={timeSlotAddData} onDrawerClose={onClose} />
        </Drawer>

        <div className="tableView">
          <div className="form-content">
            <TimeSlotList />
          </div>
        </div>

      </div>
    </div>
  );
};

export default TimeSlot;
